document.addEventListener("DOMContentLoaded", function () {
  // Auf document statt auf ein einzelnes .accordion-menu-Element horchen:
  // seit sections/header.liquid main_menu_linklist UND mobile_menu_linklist
  // (schmale Handy-Breite) beide ueber snippets/nav-accordion-mobile.liquid
  // rendern, kann es zwei .accordion-menu gleichzeitig im DOM geben (die
  // eine per Media Query ausgeblendet, je nach Breite). Ein
  // querySelector(".accordion-menu") haette nur das erste gefunden und
  // gebunden, das zweite Akkordeon waere komplett tot gewesen.
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".accordion-menu")) return;

    // Der Button umschliesst jetzt ein SVG-Chevron (icon-nav-arrow-down) statt
    // reinem Text - ein Klick auf den Pfeil landet als e.target auf <svg>/<path>,
    // nicht auf .toggle-btn selbst, darum hier hoch bis zum Button suchen.
    var toggleButton = e.target.closest(".toggle-btn");
    if (!toggleButton) return;

    e.preventDefault();

    const currentItem = toggleButton.closest(".accordion-item");
    const currentContent = currentItem.querySelector(":scope > .accordion-content");
    const currentButton = toggleButton;

    // Close all items at same level
    const parentList = currentItem.parentElement;
    const siblingItems = parentList.querySelectorAll(":scope > .accordion-item");

    siblingItems.forEach(function (item) {
      const content = item.querySelector(":scope > .accordion-content");
      const button = item.querySelector(":scope > .accordion-header .toggle-btn");

      if (item !== currentItem && content) {
        content.style.display = "none";
        if (button) button.classList.remove("is-open");
      }
    });

    // "Shop by color" rendert als 2-spaltiges Swatch-Raster statt Text-Liste
    // (siehe sections/header.liquid) - offener Zustand braucht display:grid,
    // nicht block, sonst faellt das Raster auf eine Spalte zusammen.
    var openDisplay = currentContent.classList.contains("accordion-content--colors") ? "grid" : "block";

    // Toggle current item. Der Pfeil rotiert per CSS ueber .is-open
    // (transition:transform, siehe assets/custom.css), kein Text-Glyph mehr.
    if (currentContent.style.display === openDisplay) {
      currentContent.style.display = "none";
      currentButton.classList.remove("is-open");
    } else {
      currentContent.style.display = openDisplay;
      currentButton.classList.add("is-open");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Die 3 Promo-Bilder im mobilen Drawer (New In/Bestsellers/Loved on IG):
  // is-loading blieb dauerhaft am .image-wrapper haengen, unabhaengig von
  // lazy/eager. Eigentliche Ursache liegt in snippets/image.liquid: dort wird
  // eine is-loading-Klasse fuer das <img> vorbereitet (img_class-Variable),
  // aber nie tatsaechlich gesetzt - der finale image_tag-Aufruf uebergibt nie
  // class: img_class. theme.js' eigenes Aufraeum-Script
  // (loadedImagesEventHook) prueft aber genau diese Klasse auf dem <img>,
  // bevor es is-loading vom umschliessenden Figure entfernt; die Pruefung
  // schlaegt darum IMMER fehl, is-loading bleibt fuer immer am Figure -
  // dauerhaft sichtbarer Platzhalter-Hintergrund plus endlose
  // Shimmer-Animation (theme.css, translateX(-100%) -> translateX(100%)),
  // die wie ein seitliches Ziehen/ein Slider wirkt. Das ist ein latenter
  // Bug in einem gemeinsam genutzten Snippet (theoretisch ueberall im Theme,
  // wo show_backfill Bilder rendert) - hier bewusst nur fuer unsere 3 Bilder
  // eigenstaendig geloest statt das geteilte Snippet anzufassen: eigenes
  // load-Event pro Bild, is-loading manuell vom Wrapper entfernt, sobald das
  // Bild wirklich fertig ist.
  document.querySelectorAll(".fj-promo-grid.blocks-3 img").forEach(function (img) {
    img.loading = "eager";

    function clearLoadingState() {
      var wrapper = img.closest(".image-wrapper");
      if (wrapper) wrapper.classList.remove("is-loading");
    }

    if (img.complete) {
      clearLoadingState();
    } else {
      img.addEventListener("load", clearLoadingState);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Such-Pille im Drawer (snippets/drawer-search-and-promo.liquid): ist ein
  // echtes natives <summary>, ein echter Tap oeffnet/schliesst das
  // Original-Overlay korrekt - ABER .drawer__inner haelt beim Auf-/Zufahren
  // per animation-fill-mode:forwards dauerhaft ein transform (translateX),
  // und ein transform auf einem Vorfahren erzeugt einen neuen
  // CSS-Containing-Block fuer die position:absolute-basierte
  // .search-popdown. Solange das steht, positioniert sich das Overlay
  // relativ zum Drawer statt zum Viewport - Schliessen-Button und
  // Klick-ausserhalb-Flaeche landen dadurch effektiv ausserhalb des
  // erreichbaren Bereichs.
  //
  // Fix: waehrend unsere Suche offen ist, das transform auf .drawer__inner
  // per Klasse hart auf "none" setzen - die Endposition (offen) haelt
  // assets/custom.css waehrenddessen stattdessen ueber left:0, da die
  // Grundposition left:100vw ist und erst das transform
  // (translateX(-100%), nicht translateX(0)!) sie auf den Bildschirm zieht;
  // transform allein auf none zu setzen liess den Drawer optisch zuklappen.
  // .search-popdown bekommt durch das entfernte transform sofort wieder den
  // Viewport als Containing-Block und positioniert/schliesst sich korrekt.
  document.querySelectorAll(".fj-drawer-search details").forEach(function (details) {
    var drawerInner = details.closest(".drawer__inner");
    if (!drawerInner) return;

    details.addEventListener("toggle", function () {
      drawerInner.classList.toggle("fj-search-open", details.open);
    });
  });
});

function homeCollectionlList() {
  if (window.innerWidth > 1199) {
    var home_collection = document.querySelectorAll('.home_collection .collection-list .collection-item');
    var collectionList = document.querySelector('.home_collection .collection-list');
    if (collectionList && home_collection.length > 0 && home_collection.length < 5) {
      var listWidth = collectionList.offsetWidth;
      var itemWidth = (listWidth / home_collection.length) - 35;
      //console.log(home_collection.length, listWidth, itemWidth);
      home_collection.forEach(function(item) {
        item.style.flex = "0 0 " + itemWidth + "px";
        item.style.maxWidth = itemWidth + "px";
      });
    }
  }
}
window.addEventListener("load", homeCollectionlList);
window.addEventListener("resize", homeCollectionlList);

jQuery(".size_variants li.get_option2").click(async function (event) {
  let product_id = jQuery(this).attr("data-product_id");
  let option = jQuery(this).attr("data-option");
  let optionurl = jQuery(this).attr("data-optionurl");
  let handel = jQuery(this).attr("data-handel");
  let li_option = "";
  jQuery(".product_option_" + product_id + " .length_variants_option").html("");
  try {
    jQuery(this).siblings().removeClass("active");
    jQuery(this).addClass("active");
    let products = await JSON.parse(
      document.querySelector(
        ".script_data_" + product_id + ' script[type="application/ld+json"]'
      ).textContent
    );
    if (!products) return;
    products.forEach((product) => {
      if (product.option1 === option) {
        if (product.available) {
          li_option =
            '<li class="available" data-varientid="' +
            product.id +
            '" data-handel="' +
            handel +
            '">' +
            product.option2 +
            "</li>";
        } else {
          li_option =
            '<li class="unavailable" data-url="' +
            optionurl +
            product.id +
            '">' +
            product.option2 +
            "</li>";
        }
        jQuery(
          ".product_option_" + product_id + " .length_variants_option"
        ).show();
        jQuery(
          ".product_option_" + product_id + " .length_variants_option"
        ).append(li_option);
        jQuery(
          ".product_option_" + product_id + " .length_variants_option"
        ).append('<div class="loader_variant_add" style="display:none"></div>');
      }
    });
  } catch (error) {
    console.error("Error:", error);
    sizeVariantsdisplayCartError(
      "An error occurred while adding the product to the cart."
    );
  }
});

jQuery(window).resize(async function (event) {
  productDetailsImgSrcset();
});
jQuery(document).ready(async function (event) {
  productDetailsImgSrcset();

  setTimeout(function () {
    //jQuery('html[lang="en"] #BIS_trigger').text("Join waitlist");
    jQuery('html[lang="de"] .klaviyo-bis-trigger').text("Benachrichtige mich");
    /*if (jQuery("#BIS_trigger").length == 0) {
      jQuery(
        'html[lang="de"] .product-single__sticky.variant--soldout .product-form:eq(0)'
      ).append(
        '<button id="BIS_trigger" type="button" class="btn" style="margin-top: 10px; width: 100%; color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); border: 2px solid rgb(0, 0, 0);">Benachrichtige mich</button>'
      );
    }*/
  }, 2000);
  try {
    let cart = await fetchCart();
    if (!cart) return;

    let cartItems = cart.item_count;
    let totalPrice = cart.items_subtotal_price;
    let currency = cart.currency;

    if (totalPrice) {
      // if (totalPrice > 13000 && currency === "GBP") {
      //   let paymentButtonWrapper = document.querySelector(".cart__aside");
      //   let cart__checkout = document.querySelector(
      //     ".cart__buttons-wrapper .cart__checkout"
      //   );
      //   if (paymentButtonWrapper) {
      //     // Insert the error message
      //     paymentButtonWrapper.insertAdjacentHTML(
      //       "afterbegin",
      //       `<div id="cart-error" style="color: red;">Your order value exceeds GBP 135 and cannot be processed.</div>`
      //     );
      //     cart__checkout.disabled = true;
      //   }
      // }
    }
  } catch (error) {
    console.error("Error:", error);
    sizeVariantsdisplayCartError(
      "An error occurred while adding the product to the cart."
    );
  }
});
/*jQuery("body").on("click", 'input[type="radio"]', function (e) {
  console.log(jQuery(this).hasClass("sold-out"));
  if (jQuery(this).hasClass("sold-out")) {
    if (jQuery("#BIS_trigger").length == 0) {
      jQuery('html[lang="en"] #BIS_trigger').text("Join waitlist");
      jQuery('html[lang="de"] .product-form').append(
        '<button id="BIS_trigger" type="button" class="btn" style="margin-top: 10px; width: 100%; color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); border: 2px solid rgb(0, 0, 0);">Benachrichtige mich</button>'
      );
    }
  } else {
    jQuery('html[lang="de"] #BIS_trigger').remove();
  }
});*/
document.body.addEventListener('click', handler);
document.body.addEventListener('touchstart', handler);

function handler(e) {
  // Check if the clicked (or touched) element matches the selector or is inside it
  const target = e.target;
  // Use closest to find .quick-add__button inside .mob-cart-btn
  const button = target.closest('.mob-cart-btn .quick-add__button');
  if (!button) return;

  e.preventDefault();

  // Find the closest parent with class 'product-item'
  const productItem = button.closest('.product-item');
  if (!productItem) return;

  // Find .mob-quick-cart inside that product-item
  const quickCart = productItem.querySelector('.mob-quick-cart');
  if (!quickCart) return;

  // Trigger click event on .mob-quick-cart
  quickCart.click();
}
/*jQuery("body").on("click", ".size_variants .available", async function (event) {
  let selecter = jQuery(this);
  let variantId = selecter.attr("data-varientid");
  let productHandle = selecter.attr("data-handel");
  console.log(event);

   let baseCurrency = selecter.attr("data-currency");
  let ActiveCurrency = window.Shopify.currency.active;
  let currencyRate = parseFloat(window.Shopify.currency.rate); 
   console.log('rate',currencyRate);
  console.log('base currency',baseCurrency);
  console.log('Actibe currency',ActiveCurrency);
  // Convert the variant price to the selected currency
//let convertedPrice = (variant.price / 100) * rates[storeCurrency]; 

  if (variantId != "") {
    try {
      let cart = await fetchCart();
      if (!cart) return;

      let cartItems = cart.item_count;
      let cartSubtotal = cart.items_subtotal_price;
      let currency = cart.currency;

      let product = await fetchProduct(productHandle);
      if (!product) return;

      let variant = product.variants.find((v) => v.id == variantId);

      if (variant) {
        let price = parseInt(variant.price); // Price is returned in cents, convert to dollars
        console.log('item price',variant.price);
        let totalPrice = cartSubtotal + price;
        console.log('Total price',totalPrice);
        if (totalPrice > 13000 && currency === "GBP") {
          sizeVariantsdisplayCartError(
            "Your order value exceeds GBP 135 and cannot be processed.",
            selecter
          );
          return;
        }
        console.log(cartItems);
        if (cartItems >= 6) {
          sizeVariantsdisplayCartError(
            "Please note that you cannot order more than 6 items at once",
            selecter
          );
          return;
        }

        // Proceed with adding to cart if checks are passed
        let formData = {
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        };
        const form = document.getElementById("AddToCartForm");

        let loader_html =
          '<img src="https://cdn.shopify.com/s/files/1/2635/7800/files/giftools.gif?v=1713423496">';
        selecter
          .parents(".size_variants")
          .find(".loader_variant_add")
          .show()
          .html(loader_html);
        await addItemToCart(formData);
        selecter
          .parents(".size_variants")
          .find(".loader_variant_add")
          .hide()
          .html();
      }
    } catch (error) {
      console.error("Error:", error);
      sizeVariantsdisplayCartError(
        "An error occurred while adding the product to the cart.",
        selecter
      );
    }
  }
});*/

jQuery("body").on(
  "click",
  "toggle-ellipsis.is-enabled .caps--link",
  function (params) {
    var toggle_ellipsis = jQuery(this).closest("toggle-ellipsis");
    console.log(toggle_ellipsis.hasClass("is-open-r"));
    if (toggle_ellipsis.hasClass("is-open-r")) {
      toggle_ellipsis
        .css("--height", toggle_ellipsis.attr("data-height") + "px")
        .removeClass("is-open is-open-r");
      toggle_ellipsis.find(".toggle-ellipsis__content").css("height", "");
      console.log(toggle_ellipsis.attr("data-height"));
      if (jQuery("html").attr("lang") == "de") {
        jQuery(this, "span").text("Mehr erfahren");
      } else {
        jQuery(this, "span").text("Show more");
      }
    } else {
      let ellipsis_content = parseInt(
        jQuery(".toggle-ellipsis__content").height() + 30
      );
      let ellipsis_main_height = parseInt(
        jQuery(".toggle-ellipsis__content").height() + 40
      );
      toggle_ellipsis.css("--height", ellipsis_main_height + "px");
      toggle_ellipsis
        .find(".toggle-ellipsis__content")
        .css("height", ellipsis_content + "px");
      toggle_ellipsis.toggleClass("is-open-r");
      if (jQuery("html").attr("lang") == "de") {
        jQuery(this, "span").text("weniger");
      } else {
        jQuery(this, "span").text("Show less");
      }
    }
  }
);
jQuery("body").on("click", ".drawer__close, .drawer__underlay", function () {
  setTimeout(function () {
    jQuery(".cart-block, .cart__item").removeClass("is-hiding");
    jQuery(".drawer--cart").removeClass("is-closing");
  }, 100);
  jQuery(".cart-block, .cart__item").removeClass("is-animated");
  jQuery(".cart-block, .cart__item").addClass("is-hiding");
  jQuery(".drawer--cart").removeClass("is-open");
  jQuery(".drawer--cart").addClass("is-closing");
  jQuery("body").css({ "padding-right": "" , 'overflow': ''});
  jQuery('nav.collection__nav.collection__nav--sort.collection__nav--filter').css('width', '100%');
});

function productDetailsImgSrcset() {
  if (jQuery(window).width() < 769) {
    jQuery(".template-product .product__slide .product__photo img").each(
      function () {
        jQuery(this).attr("srcset", "");
      }
    );
  }
}
async function fetchCart() {
  try {
    let cart_response = await fetch(`${window.Shopify.routes.root}cart.js`);
    return await cart_response.json();
  } catch (error) {
    console.error("Error fetching cart:", error);
    displayCartError("An error occurred while fetching the cart.");
    return null;
  }
}

function getProductDetails(productHandle, variantId) {
  //console.log(`${productHandle}: ${variantId}`);
  if(!productHandle){
    /*const searchParams = new URLSearchParams(window.location.search);
    let variantId = searchParams.has("variant")
    ? searchParams.get("variant")
    : document.getElementById("variant_id").value;*/
    productHandle = document.getElementById("product_handle").value;
  }  
  return { variantId, productHandle };
}

async function fetchProduct(productHandle) {
  try {
    let response = await fetch(
      `${window.Shopify.routes.root}products/${productHandle}.js`
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching product:", error);
    displayCartError("An error occurred while fetching the product.");
    return null;
  }
}

async function addItemToCart(formData) {
  try {
    // Add item to cart
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    // Update the cart drawer
    const response = await fetch("/");
    const data = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const cartDrawerContent = doc.querySelector(".drawer--cart").innerHTML;
    document.querySelector(".drawer--cart").innerHTML = cartDrawerContent;
    jQuery(".header__cart__status").html(
      $(doc).find(".header__cart__status").html()
    );
    //jQuery(".drawer--cart").removeClass("is-empty");
    // Open the cart drawer
/******************************************* ny code here**************/

 document.querySelector('cart-drawer')?.dispatchEvent(
      new CustomEvent('theme:cart-drawer:show', { bubbles: true })
    );

/******************************************* ny code here**************/    
    jQuery(".drawer--cart").removeClass("is-empty");
    // Open the cart drawer 
    document.querySelector(".navlink--cart").click();
  } catch (error) {
    console.error("Error adding item to cart:", error);
    displayCartError("An error occurred while adding the product to the cart.");
  }
}

function displayCartError(message) {
  alertify.set("notifier", "position", "top-right");
  alertify.warning(message);
}

function sizeVariantsdisplayCartError(message, selecter) {
  alertify.set("notifier", "position", "top-right");
  alertify.warning(message);
}
jQuery(".size_variants .unavailable").click(function () {
  if (!jQuery(this).hasClass("get_option2")) {
    var variant_url = jQuery(this).attr("data-url");
    console.log(variant_url);
    window.location.href = variant_url;
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const accordion = document.querySelector(".accordion-menu");

//   accordion.addEventListener("click", function (e) {
//     if (!e.target.classList.contains("toggle-btn")) return;

//     e.preventDefault();

//     const currentItem = e.target.closest(".accordion-item");
//     const currentContent = currentItem.querySelector(":scope > .accordion-content");
//     const currentButton = e.target;

//     // Close all items at same level
//     const parentList = currentItem.parentElement;
//     const siblingItems = parentList.querySelectorAll(":scope > .accordion-item");

//     siblingItems.forEach(function (item) {
//       const content = item.querySelector(":scope > .accordion-content");
//       const button = item.querySelector(":scope > .accordion-header .toggle-btn");

//       if (item !== currentItem && content) {
//         content.style.display = "none";
//         if (button) button.textContent = "+";
//       }
//     });

//     // Toggle current item
//     if (currentContent.style.display === "block") {
//       currentContent.style.display = "none";
//       currentButton.textContent = "+";
//     } else {
//       currentContent.style.display = "block";
//       currentButton.textContent = "-";
//     }
//   });
// });


